import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { Helpers } from '../../../helpers/helpers';
import { ElementService } from '../../../services/element.service';
import { LanguageApp } from '../../../config/datatable-config';
import { ToastrService } from 'ngx-toastr';
import { Status } from '../../../enums/status';
import { ElementType } from 'src/app/enums/element';
import { FeriaService } from 'src/app/services/feria.service';
import { SharedService } from 'src/app/services/shared.service';
import { StihlFeriaDTO, StihlFeriaOrderDTO } from 'src/app/models/stihl-feria-dto';
import { visibleContentAnimation } from 'src/app/animations';
import { FileService } from 'src/app/services/file.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormDataDTO } from 'src/app/models/form-data-dto';
import * as moment from 'moment';
declare var initForm: any;


@Component({
  selector: 'app-feria-order-detail',
  templateUrl: './feria-order-detail.component.html',
  animations: [visibleContentAnimation]
})
export class FeriaOrderDetailComponent implements OnInit {

  // Flag para ocultar el estado en la vista cliente ('mi-area'). En zona-stihl siempre se muestra.
  readonly SHOW_STATUS_TO_CLIENT = true;

  @Input() idOrder: string;
  @Input() origin: string;
  order: StihlFeriaOrderDTO;
  model: StihlFeriaDTO;
  formData: FormDataDTO;
  formDataValues: any[];
  formList: FormDataDTO[] = [];
  HTML_FORM_ORDER;
  statusList: any[] = [];
  selectedIdStatus: string;

  constructor(private feriaService: FeriaService, private router: Router,
    private fileService: FileService,
    public datepipe: DatePipe,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private helper: Helpers) { }

  ngOnInit(): void {

    this.getStatusList();
    this.getOrder();
  }

  get showStatus(): boolean {
    return this.origin != 'mi-area' || this.SHOW_STATUS_TO_CLIENT;
  }

  getStatusList() {
    this.sharedService.getStihlCustomStatus([Status.Pendiente, Status.ContactoComEscultor, Status.EnvioDeKitDeEventos, Status.Concluido]).subscribe(res => {
      this.statusList = res;
    });
  }





  getOrder() {
    this.feriaService.getFeriaOrder(this.idOrder).subscribe(res => {
      this.order = res;
      this.selectedIdStatus = res.IdStatus.toString();
      this.formDataValues = JSON.parse(this.order.Data);
      this.formDataValues.forEach(elem => {
        if (elem.VALUE == '') elem.VALUE = '.';
      });
      // this.getFeria();
    })
  }

  save() {

    let hasError = false;

    for (let i = 0; i < this.formDataValues.length; i++) {

      if (this.formDataValues[i].VALUE == "") {
        hasError = true;
        break;
      }

    }

    if (!hasError) {

      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: 'Espere por favor...'
      });
      Swal.showLoading();

      this.order.Data = JSON.stringify(this.formDataValues);
      this.order.IdStatus = +this.selectedIdStatus;
      if (this.origin == 'zona-stihl')
        this.order.IsStihlComment = true;

      this.feriaService.updateFeriaOrder(this.order.IdOrder, this.order).subscribe(res => {
        Swal.close();
        this.goBack();
      });

    } else {
      Swal.fire({
        icon: 'info',
        title: 'verifique os campos obrigatórios',

      });
    }

  }

  goBack() {
    if (this.origin == 'mi-area')
      this.router.navigate(["/myarea/orders-fairs/"]);
    else
      this.router.navigate(["/area-stihl/orders-fairs/"]);
  }
}
